<template>
  <div
    test-id="notification"
    class="p-3 mb-3 text-xs md:text-sm text-error-10 bg-error-bg rounded-lg border border-gray-26 flex gap-2 items-start"
  >
    <span test-id="icon">
      <alert-icon color="#D71841" />
    </span>
    <div class="text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisputeNotification',
  components: {
    AlertIcon: () => import('@/assets/v2/icons/InfoTwoIcon.vue')
  }
}
</script>

<style scoped>
.text {
  margin-top: 2px;
}
</style>
